// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ProfileSettingsPopup_tabs__1r_YN","tab":"ProfileSettingsPopup_tab__1aZEz","tabSelected":"ProfileSettingsPopup_tabSelected__Rom2-"};